import { createSelector } from "reselect";
import { filter } from "@utils/fuzzySearch";

const selected = ({ selected }) => selected;

const merchants = ({ merchantArray }) =>
  merchantArray.filter(card => card.cardsAvailable > 0);

const merchantsForCategory = ({ merchantArray }) => merchantArray;

const merchantsNew = ({ newMerchantArray }) => newMerchantArray;

const merchantsUnavailableCards = ({ merchantArray }) =>
  merchantArray.filter(card => card.cardsAvailable === 0);

const currentSearch = ({ currentSearch }) => currentSearch;

const filterCards = ({ filterCards }) => filterCards;

const location = ({ location }) => location;
const currentCategory = ({ categories, categoryName }) => {
  for (const categoryType of categories) {
    for (const category of categoryType.categories) {
      if (category.url === categoryName) {
        return category;
      }
    }
  }
};

const testCurrentCategory = ({ categories, categoryName }) => {
  for (const categoryType of categories) {
    for (const category of categoryType.categories) {
      if (category.url === categoryName) {
        return { category, listId: categoryType.listId };
      }
    }
  }
};

export const getMerchantArray = createSelector(
  merchants,
  filterCards,
  currentSearch,
  merchantsUnavailableCards,
  (
    merchantsParam,
    filterCardsParam,
    currentSearchParam,
    merchantsUnavaliableParam
  ) => {
    if (currentSearchParam) {
      let filterArray = filter({
        merchants: [...merchantsParam.sort((a, b) => b.popular - a.popular)],
        pattern: currentSearchParam,
        threshold: -1500
      });

      let filterArrayUnavailable = filter({
        merchants: [
          ...merchantsUnavaliableParam.sort((a, b) => b.popular - a.popular)
        ],
        pattern: currentSearchParam,
        threshold: -1500
      });

      return filterArray.concat(filterArrayUnavailable);
    }
    switch (filterCardsParam) {
      case "ALL":
        return [
          ...merchantsParam.sort((a, b) => {
            if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
            if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
            return 0;
          })
        ];
      case "HIGHEST_DISCOUNT":
        return [
          ...merchantsParam.sort(
            (item, nextItem) =>
              Number(nextItem.upToPercentage) - Number(item.upToPercentage)
          )
        ];
      case "POPULARITY":
        return [
          ...merchantsParam.sort(
            (a, b) => Number(b.popular) - Number(a.popular)
          )
        ];
      default:
        break;
    }
  }
);

export const getCategoryMerchantArray = createSelector(
  merchants,
  merchantsForCategory,
  filterCards,
  currentCategory,
  currentSearch,
  (
    merchantsParam,
    merchantsForCategoryParam,
    filterCardsParam,
    currentCategoryParam,
    currentSearchParam
  ) => {
    const merchantArrayToMap =
      currentCategoryParam.url === "discounted-deals-cards" ||
      currentCategoryParam.url === "discounted-clearance-cards"
        ? merchantsForCategoryParam
        : merchantsParam;

    if (currentSearchParam) {
      const filteredArrayAvailableCards = [
        ...merchantArrayToMap.filter(merchant => {
          const id = "" + merchant.id;
          return currentCategoryParam.merchants.indexOf(id) !== -1;
        })
      ];
      return filter({
        merchants: filteredArrayAvailableCards.sort(
          (a, b) => b.popular - a.popular
        ),
        pattern: currentSearchParam,
        threshold: -1500
      });
    }
    switch (filterCardsParam) {
      case "ALL":
        return [
          ...merchantArrayToMap
            .filter(merchant => {
              const id = "" + merchant.id;
              return currentCategoryParam.merchants.indexOf(id) !== -1;
            })
            .sort((a, b) => {
              if (a.name < b.name) return -1;
              if (a.name > b.name) return 1;
              return 0;
            })
        ];
      case "HIGHEST_DISCOUNT":
        return [
          ...merchantArrayToMap
            .filter(merchant => {
              const id = "" + merchant.id;
              return currentCategoryParam.merchants.indexOf(id) !== -1;
            })
            .sort(
              (item, nextItem) =>
                Number(nextItem.upToPercentage) - Number(item.upToPercentage)
            )
        ];
      case "POPULARITY":
        return [
          ...merchantArrayToMap
            .filter(merchant => {
              const id = "" + merchant.id;
              return currentCategoryParam.merchants.indexOf(id) !== -1;
            })
            .sort(
              (item, nextItem) =>
                Number(nextItem.popular) - Number(item.popular)
            )
        ];
      default:
        break;
    }
  }
);

export const getCurrentSearch = createSelector(currentSearch, item => item);
export const getSelected = createSelector(selected, item => item);

export const getCategoryMerchantForDropdown = createSelector(
  merchants,
  merchantsNew,
  testCurrentCategory,
  location,
  currentSearch,
  merchantsUnavailableCards,
  (
    merchantsParam,
    merchantsNewParam,
    testCurrentCategoryParam,
    locationParam,
    currentSearchParam,
    merchantsUnavailableCardsParam
  ) => {
    let returnObject = [];
    let newCard = false;
    if (testCurrentCategoryParam && testCurrentCategoryParam.listId) {
      if ([3, 4].includes(testCurrentCategoryParam.listId)) {
        newCard = true;
        returnObject = [
          ...merchantsNewParam.filter(merchant => {
            let id = "" + merchant.id;
            return (
              testCurrentCategoryParam.category.merchants.indexOf(id) !== -1
            );
          })
        ];
      } else {
        returnObject = [
          ...merchantsParam.filter(merchant => {
            let id = "" + merchant.id;
            return (
              testCurrentCategoryParam.category.merchants.indexOf(id) !== -1
            );
          })
        ];
      }
    } else {
      if (locationParam.pathname.startsWith("/buy-gift-cards/new")) {
        newCard = true;
        returnObject = [...merchantsNewParam];
      } else {
        returnObject = [...merchantsParam];
      }
    }
    if (currentSearchParam) {
      returnObject = filter({
        merchants: returnObject.sort((a, b) => b.popular - a.popular),
        pattern: currentSearchParam,
        threshold: -1500
      });
      if (
        locationParam.pathname === "/buy-gift-cards/" ||
        locationParam.pathname === "/buy-gift-cards" ||
        locationParam.pathname === "/"
      ) {
        returnObject = returnObject.concat(
          filter({
            merchants: [
              ...merchantsUnavailableCardsParam.sort(
                (a, b) => b.popular - a.popular
              )
            ],
            pattern: currentSearchParam,
            threshold: -1500
          })
        );
      }
    } else {
      returnObject = returnObject.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });

      if (
        locationParam.pathname === "/buy-gift-cards/" ||
        locationParam.pathname === "/buy-gift-cards" ||
        locationParam.pathname === "/"
      ) {
        returnObject = returnObject.concat([
          ...merchantsUnavailableCardsParam.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          })
        ]);
      }
    }

    return returnObject.map(merchant => ({
      ...merchant,
      newCard
    }));
  }
);
